export function useCfFetch() {
  const event = useRequestEvent();
  const cfFetch = cfFetchBuilder(event);
  return cfFetch;
}
